
import {FormatPrice} from '@/utils'
import moment from 'moment';


const SET_LIST = (state,payload) =>{

     if(payload){
        state.items = payload.items.map((item)=>{

            const amount = (item.amount / 100)

            item.amount = FormatPrice(amount);
            item.created_at = moment(item.created_at).utc().format("DD/MM/YYYY")
            return item
        })
     }

}
 

export default {
    SET_LIST,
}